import { createContext, use } from "react"

import { initialAppSettings } from "./app-settings"
import { logger } from "./logger/logger"

const setterFallback = <T>(x: T)=> {
  logger({
    input: `setter fallback: ${JSON.stringify(x)}`,
    level: "debug",
    toast: false,
  })
}

export const settingsContextInitialValue = {
  appSettings: initialAppSettings,
  index: 0,
  isVisible: false,
  setAppSettings: (
    key: string,
    newValue: boolean | number | Record<string, number> | string,
    settingKey: AppSettingsKey,
  )=> {
    logger({
      input: `setter fallback: ${JSON.stringify({ key, newValue, settingKey })}`,
      level: "debug",
      toast: false,
    })
  },
  setIndex: setterFallback<number>,
  setIndexInStorage: (key: IndexesKey, index: number)=> {
    logger({
      input: `setter fallback: ${JSON.stringify({ index, key })}`,
      level: "debug",
      toast: false,
    })
  },
  setIsVisible: setterFallback<boolean>,
  updateAppSettings: (
    settingKey: AppSettingsKey,
    newValue: AppSettings[AppSettingsKey],
  )=> {
    logger({
      input: `setter fallback: ${JSON.stringify({ newValue, settingKey })}`,
      level: "debug",
      toast: false,
    })
  },
}

export type Settings = typeof settingsContextInitialValue

export type SettingsContextType = typeof settingsContextInitialValue

export const GO_TO_NEXT_WAITING_TIME = {
  defaultValue: 1,
  key: "go-to-next-waiting-time",
  label: "Handsfree mode(time to wait before going to next)",
  max: 3,
  min: 0.3,
  step: 0.1,
} as const

export const settingsContext = createContext<null | SettingsContextType>(null)

export const SettingsContextProvider = settingsContext.Provider

export function useSettings(): SettingsContextType {
  const value = use(settingsContext)
  if (value === null) {
    throw new Error("useSettings must be used within SettingsContextProvider")
  }
  return value
}
